<form [formGroup]="form">
  <div class="interet">Centres d'intérêt</div>
  <div class="universes" *ngIf="universes">
    <mat-radio-group [color]="color" aria-label="Select an option" class="univers_radio_button">
      <div class="label_radio_button" *ngFor="let u of universes">
        <mat-radio-button (click)="addOrDeleteUniverse(u)" (keypress)="addOrDeleteUniverse(u)" [checked]="u.checked" value="{{u.universeKey}}">
          <span class="radioLabel">{{ u?.universeName }}</span>
        </mat-radio-button>
      </div>
    </mat-radio-group>

  </div>
  <div class="form_content">
    <div class="obligatory">
      <mat-form-field appearance="outline">
        <mat-label>Nom de l'article</mat-label>
        <input id="" type="text" matInput formControlName="offerName" (input)="updatePreviewOffer('offerName')" />
      </mat-form-field>
    </div>

    <div class="obligatory">
      <mat-form-field appearance="outline">
        <mat-label>N° Acteur</mat-label>
        <mat-select formControlName="clubCode" (selectionChange)="onSelectActor($event)">
          <mat-option *ngFor="let c of clubs" [value]="c">
            <strong>{{ c.code }}</strong> - {{ c.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <ng-container *ngIf="universesSelected[0]?.universeKey === 3; else disciplineTemplate">
      <div class="obligatory">
        <mat-form-field appearance="outline">
          <mat-label>Libellé de la discipline</mat-label>
          <input id="" type="text" matInput formControlName="practicePlace" maxlength="100" />
        </mat-form-field>
      </div>
    </ng-container>
    <ng-template #disciplineTemplate>
      <ng-container *ngIf="universesSelected[0]?.universeKey === 1; else otherTemplate">
        <div class="obligatory">
          <mat-form-field appearance="outline">
            <mat-label>Libellé de l'acteur</mat-label>
            <input id="" type="text" matInput formControlName="practicePlace" maxlength="100" />
          </mat-form-field>
        </div>
      </ng-container>
      <ng-template #otherTemplate>
        <div class="obligatory">
          <mat-form-field appearance="outline" class="discipline">
            <mat-label>Disciplines et acteurs</mat-label>
            <mat-select formControlName="practicePlace" (selectionChange)="onSelectDisciplineKey($event)">
              <mat-option *ngIf="disciplines.length > 0" [value]="null" class="no-selection">Aucune sélection</mat-option>
              <mat-option *ngFor="let discipline of disciplines" [value]="discipline">{{ discipline.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-template>
    </ng-template>

    <!-- empty cell, for align descriptions  -->
    <div></div>

    <div class="obligatory">
      <h5>Descriptif court</h5>
      <div class="angular-editor">
        <angular-editor formControlName="description" [config]="editorConfig" placeholder="Descriptif court"
                        [required]="true"></angular-editor>
      </div>
    </div>

    <div>
      <h5>Informations clés</h5>
      <div class="angular-editor">
        <angular-editor formControlName="customerPromise" [config]="editorConfig"
          placeholder="Informations clés"></angular-editor>
      </div>
    </div>

    <ng-container *ngIf="offer; else noOfferTemplate">
      <div>
        <h5>Détails</h5>
        <div class="angular-editor">
          <angular-editor formControlName="informations" [config]="editorConfig"
            placeholder="Détails"></angular-editor>
        </div>
      </div>
    </ng-container>
    <ng-template #noOfferTemplate>
      <div>
        <h5>Descriptif 2</h5>
        <div class="angular-editor">
          <angular-editor formControlName="informations" [config]="editorConfig"
            placeholder="Descriptif 2"></angular-editor>
        </div>
      </div>
    </ng-template>

    <div>
      <h5>Descriptif 3</h5>
      <div class="angular-editor">
        <angular-editor formControlName="services" [config]="editorConfig"
          placeholder="Descriptif 3"></angular-editor>
      </div>
    </div>

    <div>
      <h5>Descriptif 4</h5>
      <div class="angular-editor">
        <angular-editor formControlName="prerequisites" [config]="editorConfig" placeholder="Descriptif 4"></angular-editor>
      </div>
    </div>

    <div>
      <h5>Descriptif 5</h5>
      <div class="angular-editor">
        <angular-editor formControlName="environment" [config]="editorConfig"
          placeholder="Descriptif 5"></angular-editor>
      </div>
    </div>

    <div *ngIf="form.get('hasSession')?.value">
      <mat-slide-toggle class="licenceRequired" formControlName="licenceRequired" [color]="color">
        Licence obligatoire</mat-slide-toggle>
      <app-autocomplete *ngIf="form.get('licenceRequired')?.value && !isLoadingLicences" [control]="form.get('licence')"
        [list]="licences" label="Licence" errorMsg="Veuillez sélectionner une licence">
      </app-autocomplete>
    </div>
  </div>

  <div class="places">
    <h4>Emplacements</h4>
    <div class="place-search" appearance="outline">
      <input id="" #placeSearch matInput type="text" ngx-google-places-autocomplete
        (onAddressChange)="addPlace($event); placeSearch.value=''" placeholder="Emplacement" />
      <fa-icon class="place-reset" [icon]="getFaIcon('faSearch')"></fa-icon>
    </div>
    <mat-selection-list *ngIf="places.length" class="place-list" [multiple]="false">
      <mat-list-option class="place-item" [value]="place" *ngFor="let place of places">
        <div class="place-content">{{ getPlaceString(place) }}</div>
        <fa-icon class="place-remove" [icon]="getFaIcon('faTrashAlt')" (click)="removePlace(place)" (keypress)="removePlace(place)" matTooltip="Supprimer"></fa-icon>
      </mat-list-option>
    </mat-selection-list>
  </div>

  <div class="payment_offer" *ngIf="!form.get('isInternalOffer')?.value">

    <div class="redirect-container">
      <h4 class="title-url">Redirection de l'article</h4>
      <ng-container *ngIf="forms.length > 0">
        <mat-slide-toggle size="large" (change)="isFormToggled($event)" [checked]="isFormVisible" [color]="color">
          <span>Afficher les formulaires</span>
        </mat-slide-toggle>
      </ng-container>

    </div>

    <ng-container *ngIf="!isFormVisible; else formsTemplate">
      <mat-form-field appearance="outline" class="tooltip">
        <mat-label>Url article sur le site de l'acteur</mat-label>
        <input id="" type="text" matInput formControlName="offerClubURL" />
        <fa-icon [icon]="getFaIcon('faInfoCircle')" [matTooltip]="getTooltip('externUrlOffer')" appChangeColorTheme
          attribute="color"></fa-icon>
        <mat-hint>https://www.site-externe.com/page-article</mat-hint>
      </mat-form-field>
    </ng-container>

    <ng-template #formsTemplate>
      <mat-form-field appearance="outline">
        <mat-label>Formulaires actifs</mat-label>
        <mat-select formControlName="formDefinition" (selectionChange)="onSelectForm($event)">
          <mat-option *ngIf="forms.length > 0" [value]="null" class="no-selection">Aucune sélection</mat-option>
          <mat-option *ngFor="let f of forms" [value]="f">{{ f.name }}</mat-option></mat-select>
      </mat-form-field>
    </ng-template>

    <mat-form-field appearance="outline" class="action-name">
      <mat-label>Libellé</mat-label>
      <input id="" matInput formControlName="actionName" />
    </mat-form-field>

    <ng-container *ngIf="isFormVisible">
      <mat-form-field appearance="outline">
        <mat-label>Nombre de places</mat-label>
        <input type="number" id="" matInput formControlName="placeTotal" />
      </mat-form-field>
    </ng-container>
  </div>

  <div class="title_parameter" *ngIf="form.get('hasSession')?.value">
    <h4>Paramètres</h4>
    <div class="add_parameter" (click)="addParameter()" (keypress)="addParameter()" appChangeColorTheme attribute="color"
      *ngIf="offerParameterUpdatable">
      <fa-icon [icon]="getFaIcon('faPlus')"></fa-icon>
      Ajouter un paramètre
    </div>
  </div>

  <p *ngIf="form.get('hasSession')?.value && !offerParameterUpdatable" class="italic">
    Vous ne pouvez pas éditer/ajouter des paramètres sur un article acheté ou présent dans un panier</p>

  <mat-list formArrayName="parameters" class="matList_parameters" *ngIf="form.get('hasSession')?.value">
    <mat-list-item *ngFor="let control of getArray('parameters').controls; index as i" [formGroupName]="i">
      <section class="parameter_field">
        <div class="trashFirstPageParam">
          <mat-checkbox [color]="color" formControlName="isFirstPage"
            matTooltip="En 1ère ou 2ème page du pdf de la session">En 1ère page</mat-checkbox>
          <fa-icon [icon]="getFaIcon('faTrashAlt')" (click)="removeParameter(i)" (keypress)="removeParameter(i)" matTooltip="Supprimer"
            *ngIf="offerParameterUpdatable">
          </fa-icon>
        </div>

        <app-autocomplete [control]="control.get('param')" [list]="filteredParameters" label="Paramètre"
          errorMsg="Veuillez sélectionner un paramètre" [disabled]="!offerParameterUpdatable"
          [hasTooltip]="control.value?.param?.values ? control.value?.param?.values === 'noValue' ? false : true : false"
          [tooltipText]="control.value?.param?.values ? getTooltipText(control.value?.param?.values, control.value?.param?.type) : ''">
        </app-autocomplete>
      </section>
    </mat-list-item>
  </mat-list>

  <div class="tag_title">
    <h4>Tags</h4>
  </div>
  <div class="tags" *ngIf="universesSelected.length > 0">
    <mat-accordion [multi]="false">
      <ng-container *ngFor="let t of filteredTags">
        <app-mat-accordion-tree [tags]="t" [allComplete]="t.completed"></app-mat-accordion-tree>
      </ng-container>
    </mat-accordion>
  </div>

  <div class="dates" *ngIf="universesSelected[0]?.universeKey === 8 || universesSelected[0]?.universeKey === 9">
    <mat-form-field appearance="outline" class="startdate">
      <mat-label>Date de début</mat-label>
      <input id="" matInput [matDatepicker]="datePicker" formControlName="startDate">
      <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
      <mat-datepicker #datePicker disabled="false"></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="dates" *ngIf="universesSelected[0]?.universeKey === 5">
    <mat-form-field appearance="outline" class="startdate">
      <mat-label>Date de début</mat-label>
      <input id="" matInput [matDatepicker]="datePicker" formControlName="startDate">
      <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
      <mat-datepicker #datePicker disabled="false"></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="enddate">
      <mat-label>Date de fin</mat-label>
      <input id="" matInput [matDatepicker]="endDatePicker" formControlName="endDate">
      <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #endDatePicker disabled="false"></mat-datepicker>
    </mat-form-field>
  </div>

  <p *ngIf="universesSelected.length === 0">Veuillez sélectionner au moins un centre d'intérêt pour pouvoir choisir des tags.</p>

  <h4>Tags principaux</h4>
  <div class="main_tags" *ngIf="universesSelected.length > 0">
    <mat-form-field appearance="outline">
      <mat-label>Premier tag</mat-label>
      <input id="" type="text" matInput formControlName="firstMainTag" [matAutocomplete]="auto"
        (ngModelChange)="filterMainTags('first', f.firstMainTag)" />
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let t of tagsSelected" [value]="t.tagName">
          {{ t.tagName }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field appearance="outline" *ngIf="f.firstMainTag.value">
      <mat-label>Second tag</mat-label>
      <input id="" type="text" matInput formControlName="secondMainTag" [matAutocomplete]="auto"
        (ngModelChange)="filterMainTags('second', f.secondMainTag)" />
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let t of tagsSelectedSecondMainTag" [value]="t.tagName">
          {{ t.tagName }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field appearance="outline" *ngIf="f.firstMainTag.value && f.secondMainTag.value">
      <mat-label>Troisième tag</mat-label>
      <input id="" type="text" matInput formControlName="thirdMainTag" [matAutocomplete]="auto"
        (ngModelChange)="filterMainTags('third', f.thirdMainTag)" />
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let t of tagsSelectedThirdMainTag" [value]="t.tagName">
          {{ t.tagName }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <p *ngIf="universesSelected.length === 0">Veuillez sélectionner au moins un centre d'intérêt pour pouvoir choisir des tags principaux.</p>

  <!-- Images -->

  <h4>Image principale</h4>

  <div class="upload_img">
    <div class="upload">
      <div class="input">
        <div class="input_uplaod_perso" appChangeColorTheme attribute="bgc">
          <fa-icon [icon]="getFaIcon('faUpload')"></fa-icon>
          <p>Importer une image principale</p>
        </div>
        <p class="size_max">Taille max. 300kB, privilégier format paysage 16/9</p>
        <input id="" type="file" formControlName="image" class="input_default_file"
          (input)="updatePreviewOffer('image', $event)" />
      </div>

      <div class="input_uplaod_perso" appChangeColorTheme attribute="bgc" (click)="openDialogChooseImage()" (keypress)="openDialogChooseImage()"
        *ngIf="f.clubCode.value">
        <fa-icon [icon]="getFaIcon('faArrowAltCircleUp')"></fa-icon>
        <p>Choisir une image principale parmis celles de l'acteur</p>
      </div>

      <div [ngSwitch]="mode">
        <ng-container *ngSwitchCase="'add'">
          <div class="file_name" *ngIf="file">
            <fa-icon [icon]="getFaIcon('faFile')" appChangeColorTheme attribute="color"></fa-icon>
            {{ this.file?.name }}
          </div>
        </ng-container>

        <div class="file_name" *ngSwitchCase="'edit'">
          <fa-icon [icon]="getFaIcon('faFile')" appChangeColorTheme attribute="color"></fa-icon>
          {{ this.file ? this.file?.name : this.offerPreview?.image }}
        </div>
      </div>
    </div>
    <div class="experience_photo">
      <mat-form-field appearance="outline">
        <mat-label>Photo expérience (haut)</mat-label>
        <input id="" #photoExperienceTopInput type="text" matInput formControlName="photoExperience" maxlength="50" />
        <mat-hint align="end">Caractères: <strong>{{photoExperienceTopInput.value.length}}</strong> / 50</mat-hint>
      </mat-form-field>
    </div>
    <div class="experience_photo">
      <mat-form-field appearance="outline">
        <mat-label>Photo expérience (bas)</mat-label>
        <input id="" #photoExperienceBottomInput type="text" matInput formControlName="photoExperienceBas" maxlength="50" />
        <mat-hint align="end">Caractères: <strong>{{photoExperienceBottomInput.value.length}}</strong> / 50</mat-hint>
      </mat-form-field>
    </div>
  </div>
</form>
